import React, { useState, useEffect } from 'react';
import { Container, Box, Typography, TextField, Button, Alert } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import appLogo from "../../images/website-images/logos/app-logo.png";

import { optOutOfPPCMarketingEmails } from "../../common/FunctionCalls";

export default function OptOutOfPPCMarketingEmails() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // "success" | "error"

  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [searchParams]);

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      setStatus('error');
      return;
    }

    try {
      const success = await optOutOfPPCMarketingEmails(email);

      if (success) {
        setStatus('success');
      } else {
        throw new Error('Failed');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>

       <Box textAlign="center" pb={1}>
            <img
              src={appLogo}
              alt="App Logo"
              style={{ height: 85}}
            />
            <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
              Dineoly®
            </Typography>
      </Box>
      <Box
        component="form"
        onSubmit={handleUnsubscribe}
        sx={{
          p: 4,
          borderRadius: 4,
          boxShadow: 3,
          bgcolor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Opt Out of Marketing Emails
        </Typography>
        <Typography align="center" color="text.secondary">
          Enter your email address to stop receiving marketing emails.
        </Typography>

        <TextField
          label="Email Address"
          type="email"
          fullWidth
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button
          type="submit"
          variant="contained"
          color="error"
          size="large"
          fullWidth
        >
          Opt Out
        </Button>

        {status === 'success' && (
          <Alert severity="success">You've been successfully opted out of marketing emails.</Alert>
        )}
        {status === 'error' && (
          <Alert severity="error">Something went wrong. Please try again.</Alert>
        )}

        <Typography variant="caption" color="text.secondary" align="center" mt={2}>
          This opt-out only affects marketing emails. You may still receive important transactional messages related to your account.
        </Typography>
      </Box>
    </Container>
  );
}
